import { OrderFormInfoData, RequisitionFormData, TestType } from '@/types/RequisitionFormTypes'
import { getPatientInfoFromForm } from '@/utils/orderFormUtils'
import React from 'react'

interface OrderSummaryProps {
  orderId?: string
  orderData?: OrderFormInfoData
  formData?: RequisitionFormData | null
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ orderId, orderData, formData }) => {
  const getTestTypeDisplay = () => {
    if (!formData?.order?.selectedOption) return 'Unknown'
    switch (formData.order.selectedOption) {
      case TestType.urWGS_Patient_Only:
        return 'urWGS Proband Only (Singleton)'
      case TestType.urWGS_Duo:
        return 'urWGS Duo (Proband + One biological parent)'
      case TestType.urWGS_Trio:
        return 'urWGS Trio (Proband + Mother + Father)'
      case TestType.rWGS_Patient_Only:
        return 'Rapid WGS - Patient Only (rWGS)'
      case TestType.rWGS_Duo:
        return 'Rapid WGS - Duo (rWGS)'
      case TestType.rWGS_Trio:
        return 'Rapid WGS - Trio (rWGS)'
      default:
        return formData.order.selectedOption
    }
  }

  return (
    <div className="rounded-base border border-border-base dark:border-gray-700 bg-white dark:bg-gray-900 p-6 shadow-sm">
      <h3 className="mb-4 self-stretch text-sm leading-5 font-medium tracking-tight text-text-heading dark:text-white">Order Details</h3>
      <dl className="space-y-3">
        <div>
          <dt className="text-sm leading-5 font-medium text-text-body dark:text-gray-400">Order ID</dt>
          <dd className="mt-1 font-mono text-sm leading-5 font-medium text-text-heading dark:text-white">{orderId}</dd>
        </div>
        <div>
          <dt className="text-sm leading-5 font-medium text-text-body dark:text-gray-400">Patient Name</dt>
          <dd className="mt-1 text-sm leading-5 font-medium text-text-heading dark:text-white">
            {getPatientInfoFromForm(orderData ?? null).name || 'N/A'}
          </dd>
        </div>
        <div>
          <dt className="text-sm leading-5 font-medium text-text-body dark:text-gray-400">MRN</dt>
          <dd className="mt-1 text-sm leading-5 font-medium text-text-heading dark:text-white">{orderData?.patient?.mrn || 'N/A'}</dd>
        </div>
        <div>
          <dt className="text-sm leading-5 font-medium text-text-body dark:text-gray-400">Test Type</dt>
          <dd className="mt-1 text-sm leading-5 font-medium text-text-heading dark:text-white">{getTestTypeDisplay()}</dd>
        </div>
        <div>
          <dt className="text-sm leading-5 font-medium text-text-body dark:text-gray-400">Order Date</dt>
          <dd className="mt-1 text-sm leading-5 font-medium text-text-heading dark:text-white">
            {orderData?.orderDate
              ? new Date(orderData.orderDate).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                })
              : 'N/A'}
          </dd>
        </div>
      </dl>
    </div>
  )
}

export default OrderSummary
